import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'TrimDecimalPipe' })
export class TrimDecimalPipe implements PipeTransform {
  transform(val) {
    return val.toFixed(2);
  }
}
